class StickyATC extends HTMLElement {
  constructor() {
    super();
    this.showAfter = 200;
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.variantSelect = this.querySelector('select[name="id"]');
    this.image = this.querySelector('.sticky-atc-image img');
    this.priceValues = this.querySelector('.product-price-values');
    this.productButtons = this.querySelector('product-buy-buttons');

    this.setShowAfter();
    this.onScroll();
    this.updateFromOption(this.variantSelect?.selectedOptions[0]);
    this.adjustBottomPadding();

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
    this.variantSelect?.addEventListener('change', this.onSelectChange);
    document.addEventListener('product:variant-change', this.onVariantChange);
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.variantSelect?.removeEventListener('change', this.onSelectChange);
    document.removeEventListener('product:variant-change', this.onVariantChange);
    document.body.style.paddingBottom = '';
  }

  getVariants() {
    const variantsScript = this.querySelector('script[data-product-variants]');
    if (!variantsScript) return [];

    try {
      const variants = JSON.parse(variantsScript.textContent || '[]');
      return Array.isArray(variants) ? variants : [];
    } catch (error) {
      console.error('Error parsing sticky add to cart variants', error);
      return [];
    }
  }

  getVariant(variantId) {
    if (!variantId) return null;
    return this.getVariants().find((variant) => String(variant.id) === String(variantId)) || null;
  }

  setShowAfter() {
    const productButtons = document.querySelector('.product-main product-buy-buttons');
    this.showAfter = productButtons ? productButtons.getBoundingClientRect().bottom + window.scrollY : 200;
  }

  onScroll() {
    this.classList.toggle('show', window.scrollY > this.showAfter);
  }

  onResize() {
    this.setShowAfter();
    this.onScroll();
    this.adjustBottomPadding();
  }

  adjustBottomPadding() {
    document.body.style.paddingBottom = `${this.clientHeight}px`;
    document.dispatchEvent(new CustomEvent('sticky-atc:height-change'));
  }

  updateImageFromOption(option) {
    if (!option || !this.image || !option.dataset.variantImage) return;

    this.image.src = option.dataset.variantImage;

    if (option.dataset.variantImageSrcset) {
      this.image.srcset = option.dataset.variantImageSrcset;
    }

    if (option.dataset.variantImageAlt !== undefined) {
      this.image.alt = option.dataset.variantImageAlt;
    }
  }

  updatePriceFromOption(option) {
    if (!option || !this.priceValues || !option.dataset.variantPrice) return;

    this.priceValues.dataset.hasPriceCompare = option.dataset.variantHasPriceCompare || 'false';
    this.priceValues.dataset.available = option.dataset.variantAvailable || 'false';

    this.priceValues.querySelectorAll('[data-price]').forEach((element) => {
      element.textContent = option.dataset.variantPrice;
    });

    this.priceValues.querySelectorAll('[data-compare-price]').forEach((element) => {
      element.textContent = option.dataset.variantComparePrice || '';
    });
  }

  updateFromOption(option) {
    this.updateImageFromOption(option);
    this.updatePriceFromOption(option);
  }

  onSelectChange(event) {
    const option = event.target.selectedOptions[0];
    const variant = this.getVariant(option?.value);

    this.updateFromOption(option);

    document.dispatchEvent(new CustomEvent('product:variant-change', {
      detail: {
        sectionId: this.sectionId,
        variant,
      },
    }));
  }

  onVariantChange(event) {
    const eventSectionId = event.detail?.sectionId || null;
    if (eventSectionId && this.sectionId && String(eventSectionId) === String(this.sectionId)) return;

    const variantId = event.detail?.variant?.id;
    if (!variantId || !this.variantSelect) return;

    this.variantSelect.value = String(variantId);
    this.updateFromOption(this.variantSelect.selectedOptions[0]);
  }
}

if (!customElements.get('sticky-atc')) {
  customElements.define('sticky-atc', StickyATC);
}
